import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ActionButton from './ActionButton';

const ActionConfirmButton = ({ onClick, text, isDisabled, cautionText, cautionOn }) => {
	const [showingCaution, setShowingCaution] = useState(false);

	const actionClick = () => {
		if (cautionOn && !showingCaution) {
			setShowingCaution(true);
		} else {
			onClick();
		}
	};

	if (!cautionOn && showingCaution) {
		setShowingCaution(false);
	}

	return (
		<div>
			{cautionOn && showingCaution && cautionText} &nbsp;
			<ActionButton onClick={actionClick} text={text} isDisabled={isDisabled} />
		</div>
	);
};

ActionConfirmButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	text: PropTypes.string.isRequired,
	isDisabled: PropTypes.bool,
	cautionOn: PropTypes.bool.isRequired,
	cautionText: PropTypes.string.isRequired
};

ActionConfirmButton.defaultProps = {
	isDisabled: false,
	cautionText: 'Any unsaved changes will be lost?'
};

export default ActionConfirmButton;
